export class MongoBaseContainer{}